module.exports = __webpack_public_path__ + "static/media/ico99.931c67a1.svg";